import { Component, Input, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LicenseService } from 'src/app/EBMSuite/services/license/license.service';
import { ProjectConstants } from 'src/assets/constants/project.constants';
import { SIBASI_SYSTEM_APP_MODULES } from 'src/app/common/model/sibasi-system.model';

@Component({
  selector: 'app-receipt-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div
      class="powered-by-section px-2 pt-8 pb-6 md:px-1 lg:px-8 mb-2 mt-auto"
      *ngIf="!isSubscribed"
    >
      <div class="text-center">
        <div class="mb-3 flex align-items-center justify-content-center">
          <span class="text-700 text-sm"> Powered by&nbsp; </span>
          <img
            [src]="'assets/images/brand/' + projectConstants.lightLogo"
            width="98"
            alt="EBM Suite"
          />
        </div>
        <div class="text-700 text-sm">
          To create your own free account visit
          <a href="http://ebmsuite.com" target="_blank">ebmsuite.com</a>
        </div>
      </div>
      <div class="grid sm:w-8 ml-auto flex justify-content-center" *ngIf="!printingView">
        <div class="col-2"></div>
        <div class="col-1">
          <img src="assets/images/img/curve-arrow.svg" style="height: 35px;" />
        </div>
        <div class="col flex align-items-end">
          <a
            class="text-link"
            routerLink="/app/settings/organization-settings/subscriptions"
            >Subscribe &nbsp;</a
          >
          <span> to remove '<b>Powered by</b>' Footer </span>
        </div>
      </div>
    </div>
  `
})
export class ReceiptFooterComponent implements OnInit {
  @Input() printingView = false;
  projectConstants = ProjectConstants;
  isSubscribed = false;
  subscriptionModulesToCheck: SIBASI_SYSTEM_APP_MODULES[] = [
    SIBASI_SYSTEM_APP_MODULES.TRANSACTION_PRINTOUTS
  ];

  // Services
  licenseService = inject(LicenseService);

  async ngOnInit(): Promise<void> {
    this.isSubscribed = await this.licenseService.checkIfMOdulesAreSubscribed(
      this.subscriptionModulesToCheck
    );
  }
}
